"use client";

import { useEffect, useState } from "react";

// ─── Error Reporter ───

function reportError(error: Error & { digest?: string }) {
  fetch("/api/error-report", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      message: error.message,
      stack: error.stack,
      digest: error.digest,
      url: typeof window !== "undefined" ? window.location.href : undefined,
      userAgent:
        typeof navigator !== "undefined" ? navigator.userAgent : undefined,
      timestamp: new Date().toISOString(),
    }),
  }).catch(() => {});
}

// ─── Global Error Boundary ───

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const [isDark] = useState(() => {
    if (typeof window === "undefined") return false;
    const preference = window.localStorage.getItem("theme");
    return preference === "dark" || (
      preference !== "light" && window.matchMedia("(prefers-color-scheme: dark)").matches
    );
  });

  useEffect(() => {
    reportError(error);
  }, [error]);

  return (
    <html lang="es" className={isDark ? "dark" : undefined} suppressHydrationWarning>
      <body className="antialiased">
        <div className="flex min-h-screen items-center justify-center bg-background p-4 font-sans text-foreground">
          <div className="max-w-md text-center">
            <h1 className="text-2xl font-semibold">
              Algo salió mal
            </h1>
            <p className="mt-3 text-sm leading-6 text-muted-foreground">
              Ocurrió un error inesperado. Nuestro equipo fue notificado.
            </p>
            {error.digest && (
              <p className="mt-2 font-mono text-xs text-muted-foreground">
                Referencia: {error.digest}
              </p>
            )}
            <button
              onClick={reset}
              className="mt-6 rounded-md bg-primary px-6 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
            >
              Reintentar
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}
